var shop_currency_default = $("#shop_currency_val").text(),
    shop_currency;
function myCartSection() {
    var e = $(".cart-side-panel .block-cart-header").height();
    $("#cart_container_id").css("top", e + "px");
}
jQuery(window).resize(function () {
    myCartSection();
}),
    (shop_currency = shop_currency_default);
var wc_theme_source = {
    lib: {
        ajax_error: function (error, message, this_click) {
            var data = eval("(" + error.responseText + ")");
            if (data.message)
                if ("grid_click" == this_click) {
                    var itrmCount = data.description.split(" ")[1];
                    jQuery(".cartCount_item").text(itrmCount),
                        jQuery("#cart_error_message").find("h5").text(data.description),
                        setTimeout(function () {
                            $("#cart_error_message").modal("show");
                        }, 500);
                } else jQuery(".responseJSON_Error").find("h5").text(data.description), jQuery(".responseJSON_Error").show();
        },
        on_cart_update: function (e) {
            setTimeout(function () {
                jQuery.getJSON("/cart.js", function (e) {
                    $(".cart_qty_cls").html(e.item_count);
                    Shopify.formatMoney(e.total_price, shop_currency_default).replace(/[^\d\.]/g, "");
                    if (e.item_count > 0) {
                        var t = Shopify.formatMoney(e.total_price, shop_currency_default);
                        $(".items_carts span").hasClass("money") ? ($(".items_carts span").remove(), $(".items_carts").html("<span class='money'>" + t + "</span>")) : $(".items_carts").html("<span class='money'>" + t + "</span>");
                    } else $(".items_carts span").remove(), $(".items_carts").html("<span class='money'>$0.00</span>");
                });
            }, 100);
        },
        on_item_added: function (e) {
            ajaxCart.load(),
                setTimeout(function () {
                    1 === e.quantity ? jQuery(".c_item_quantity").text("an") : jQuery(".c_item_quantity").text(e.quantity),
                        $(".coll_pro_featured").each(function (e) {
                            0 == $(this).find("ul.wc_pro_slider li").size() && $(this).remove();
                        });
                }, 1500);
        },
        on_product: function (e) {
            alert("Received everything we ever wanted to know about " + e.title);
        },
        addtocart_product: function (e, t, r) {
            var a = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + (t = t || 1) + "&id=" + e,
                dataType: "json",
                success: function (t) {
                    window.location.href.indexOf("/cart") > -1
                        ? location.reload()
                        : ("function" == typeof r ? r(t, e) : wc_theme_source.lib.on_item_added(t),
                          setTimeout(function () {
                              $("#close_quickview_popup").trigger("click");
                          }, 500));
                },
                error: function (e, t) {
                    wc_theme_source.lib.ajax_error(e, t);
                },
            };
            jQuery.ajax(a);
        },
        get_product: function (e, t) {
            jQuery.getJSON("/products/" + e + ".js", function (e, t) {
                wc_theme_source.lib.on_product(e);
            });
        },
        get_cart: function (e) {
            jQuery.getJSON("/cart.js", function (t, r) {
                "function" == typeof e ? e(t) : wc_theme_source.lib.on_cart_update(t);
            });
        },
        addtocart_form: function (e, t, r, a) {
            var c = {
                type: "POST",
                url: "/cart/add.js",
                data: jQuery("#" + e).serialize(),
                dataType: "json",
                beforeSend: function () {
                    jQuery("#" + e)
                        .find(".cart_btn_class")
                        .attr("disabled", !0);
                },
                success: function (r) {
                    "function" == typeof t ? t(r, e) : wc_theme_source.lib.on_item_added(r),
                        setTimeout(function () {
                            $("#close_quickview_popup").trigger("click");
                        }, 500);
                },
                error: function (e, t) {
                    "function" == typeof r ? r(e, t) : wc_theme_source.lib.ajax_error(e, t, a);
                },
            };
            jQuery.ajax(c);
        },
        cart_change_item: function (e, t, r) {
            var a = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + t + "&line=" + e,
                dataType: "json",
                success: function (e) {
                    "function" == typeof r ? r(e) : wc_theme_source.lib.on_cart_update(e);
                },
                error: function (e, t) {
                    wc_theme_source.lib.ajax_error(e, t);
                },
            };
            jQuery.ajax(a);
        },
        cart_remove_item: function (e, t) {
            var r = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=0&line=" + e,
                dataType: "json",
                beforeSend: function () {
                    jQuery(".cart_loader_cls_id").show();
                },
                success: function (e) {
                    "function" == typeof t ? t(e) : wc_theme_source.lib.on_cart_update(e), jQuery(".cart_loader_cls_id").hide();
                },
                error: function (e, t) {
                    wc_theme_source.lib.ajax_error(e, t);
                },
            };
            jQuery.ajax(r);
        },
        cart_clear_all: function () {
            var e = {
                type: "POST",
                url: "/cart/clear.js",
                data: "",
                dataType: "json",
                success: function (e) {
                    wc_theme_source.lib.on_cart_update(e);
                },
                error: function (e, t) {
                    wc_theme_source.lib.ajax_error(e, t);
                },
            };
            jQuery.ajax(e);
        },
        update_cart_form: function (e) {
            var t = {
                type: "POST",
                url: "/cart/update.js",
                data: jQuery("#" + e).serialize(),
                dataType: "json",
                beforeSend: function () {
                    jQuery("#" + e)
                        .find(".cart_btn_class")
                        .attr("disabled", !0);
                },
                success: function (t) {
                    wc_theme_source.lib.on_cart_update(t),
                        jQuery("#" + e)
                            .find(".cart_btn_class")
                            .attr("disabled", !1);
                },
                error: function (e, t) {
                    wc_theme_source.lib.ajax_error(e, t);
                },
            };
            jQuery.ajax(t);
        },
    },
};
jQuery(document).on("click", ".add_to_cart_btn_cls", function () {
    var e = $(this).data("click"),
        t = jQuery(this).closest("form").attr("id");
    return wc_theme_source.lib.addtocart_form(t, "", "", e), !1;
}),
    jQuery(document).ready(function () {
        ajaxCart.load(), myCartSection();
    });
